import Service from "./Service";
const baseurl = '/api/historia-examen-fisico';
export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByHc(id) {
        return Service.get(`${baseurl}/show-by-hc/${id}`);
    },
    showExamenByHc(id_historia) {
        return Service.get(`${baseurl}/show-examen-hc/${id_historia}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    }
}